$(document).ready(function(){
    //topbarState();

    $('.menu-toggle button').click(function() {
        $('.main-menu').toggleClass('collapsed expanded');
        $('body').toggleClass('lock-scroll');
        topbarState();
        /*if($('.main-menu').hasClass('collapsed')){
            topbarState();
            //console.log('a');
        }else{
            $('.topbar').addClass('scrolled');
            //console.log('b');
        }*/
    });

    $('.parallax').each(function( index ) {
        if($( window ).width() < 900){
            //$img = $(this).data('image-src-small');
        }else{
            $img = $(this).data('image-src-large');
            $(this).css('background', 'transparent');
            $(this).parallax({
                imageSrc: $img,
                speed: 0.4,
                bleed: 20
            });
        }
    });

    // referenties
    $(".reflogos img").click(function(e) {
        var elm = $(this).data('info');
        $('.refinfo > div').removeClass('show');
        $('.'+elm).addClass('show');
    });

    $('.reflogos').bxSlider({
        mode: 'horizontal',
        slideMargin: 30,
        minSlides: 3,
        maxSlides: 6,
        slideWidth: 220,
        auto: true,
        autoHover: true,
        controls: true,
        nextText: ' ',
        prevText: ' ',
        pager: false,
        speed: 900,
        pause: 6000
    });

    /*
     * Google Analytics events for mailto and tel links
     */
    $("[href*='tel:'], [href*='mailto:']").click(function(e) {
        var href = $(this).attr('href');

        // tel:
        if (href.toLowerCase().indexOf("tel:") >= 0) {
            eventCategory = 'Call';
            eventLabel = href.replace('tel:', '');
        }

        // mailto:
        if (href.toLowerCase().indexOf("mailto:") >= 0) {
            eventCategory = 'E-mail';
            eventLabel = href.replace('mailto:', '');
        }

        // whatsapp:
        if (href.toLowerCase().indexOf("api.whatsapp.com") >= 0) {
            eventCategory = 'Whatsapp';
            eventLabel = '-';
        }
        console.log('GA Event: ' + eventCategory + ' - ' + eventLabel);

        if (window.gtag) {
            e.preventDefault();

            //ga('send', 'event', eventCategory, 'Click', eventLabel);
            gtag('event', 'Click', {
                'event_category': eventCategory,
                'event_label': eventLabel
            });

            setTimeout(function() {
                window.location = href;
            }, 500);
        }
    });
});

$(window).scroll(function(){
    //topbarState();
});

function topbarState(){
    var scrolled=$(window).scrollTop();
    //console.log(scrolled);
    if($('.main-menu').hasClass('expanded') || scrolled > 30){
        $('.topbar').addClass('scrolled');
    } else {
        $('.topbar').removeClass('scrolled');
    }
}